export function initializeApplication() {
  return { type: "INITIALIZE_APPLICATION" }
}